import Main from "./main.js";

export default Main;
